import React, { ReactElement } from 'react'
import { useQueueSnapshot } from '../../Hooks/useQueueSnapshot'
import { deriveMyQueueStatus } from '../../utils/queueStatus'
import * as Styled from './Queue.styled'

// รับ `match` ทั้งก้อนแล้ว annotate ข้างใน — สำนวนเดียวกับ MenuDetail
// เขียน match.params.queueNumber ตรงๆ ใน render prop ไม่ได้: tsconfig ตั้ง strict: true
// และ react-router type params ของ Route เป็น {} → tsc ไม่ผ่าน
interface IParams {
  params: {
    queueNumber: string
  }
}

const MyQueue = ({ match }): ReactElement => {
  const { snapshot, stale } = useQueueSnapshot()
  const { params }: IParams = match
  const parsed = Number(params.queueNumber)
  const valid = Number.isInteger(parsed) && parsed > 0

  if (!valid) {
    return (
      <Styled.Page>
        <Styled.Headline>Invalid queue number</Styled.Headline>
        <Styled.LinkBtn href='/queue'>View queue board</Styled.LinkBtn>
      </Styled.Page>
    )
  }

  if (!snapshot) {
    if (!stale) {
      return (
        <Styled.Page>
          <Styled.Sub>Loading…</Styled.Sub>
        </Styled.Page>
      )
    }

    return (
      <Styled.Page>
        <Styled.Label>Your queue</Styled.Label>
        <Styled.BigNumber>R{parsed}</Styled.BigNumber>
        <Styled.Headline>Can&apos;t reach the queue</Styled.Headline>
        <Styled.Sub>Still trying — this page keeps retrying automatically.</Styled.Sub>
        <Styled.Foot>Reconnecting…</Styled.Foot>
      </Styled.Page>
    )
  }

  const status = deriveMyQueueStatus(parsed, snapshot)

  return (
    <Styled.Page>
      <Styled.Label>Your queue</Styled.Label>
      <Styled.BigNumber>R{parsed}</Styled.BigNumber>

      {status.state === 'waiting' && (
        <>
          <Styled.Headline>
            {status.ahead === 0
              ? "You're next"
              : `${status.ahead} ${status.ahead === 1 ? 'order' : 'orders'} ahead`}
          </Styled.Headline>
          <Styled.Sub>
            {snapshot.nowServing === null
              ? 'No orders served yet'
              : `Now serving R${snapshot.nowServing}`}
          </Styled.Sub>
        </>
      )}

      {status.state === 'ready' && (
        <>
          <Styled.Ready>Ready for pickup</Styled.Ready>
          <Styled.Sub>Collect at the counter</Styled.Sub>
        </>
      )}

      {status.state === 'unknown' && (
        <>
          <Styled.Headline>Not in today&apos;s list</Styled.Headline>
          <Styled.Sub>This queue number is not from today.</Styled.Sub>
          <Styled.LinkBtn href='/queue'>View queue board</Styled.LinkBtn>
        </>
      )}

      <Styled.Foot>{stale ? 'Reconnecting…' : 'Updates every 10 seconds'}</Styled.Foot>
    </Styled.Page>
  )
}

export default MyQueue
